// @flow

import axios from 'axios';

const API_URL = 'https://beta.bosti.kg/api';

const axiosConfig = {
  baseURL: API_URL,
  timeout: 3000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Key-Inflection': 'camel',
  },
};

export function getCategories(locale: string) {
  return (
    axios.create(axiosConfig)
      .get('/categories', {
        params: { locale },
      })
  );
}

export function getCategory(id: number, locale: string) {
  return (
    axios.create(axiosConfig)
      .get(`/categories/${id}`, {
        params: { locale },
      })
  );
}

export function getProduct(id: number, locale: string) {
  return (
    axios.create(axiosConfig)
      .get(`/products/${id}`, {
        params: { locale },
      })
  );
}

export function getArticle(id: number, locale: string) {
  return (
    axios.create(axiosConfig)
      .get(`/articles/${id}`, {
        params: { locale },
      })
  );
}



// WEBPACK FOOTER //
// ./src/api.js